export const worldConfig = {
    WORLD_SIZE: 4000,
    TILE_SIZE: 16,
    WORLD_TILE_DIMENSIONS: 4000 / 16
};
